import { FieldError } from 'react-hook-form'
import { cn } from '@global/utils/tailwind'

interface FormErrorProps {
  error?: FieldError
  className?: string
}

export const FormError = ({ error, className }: FormErrorProps) =>
  error?.message ? (
    <p className={cn('text-sm text-red-500 mt-1', className)}>{error.message}</p>
  ) : null
